export const PROVIDERS = {
  OKTA: { name: "okta", route: "auth/okta" },
  GOOGLE: { name: "google", route: "auth/google" },
  MICROSOFT: { name: "microsoft", route: "auth/microsoft" },
  NONE: { name: "none" },
};

export const ALTERNATIVE_STRATEGY_QUERY = "strategy";
